export type GetAccessorsBetweenRequest = { initialAccessor: number[]; finalAccessor: number[]; arrayLengths: number[]; incrementBy: number }

/**
 * @function incrementAccessor inline increments values of arrays based on radix implied for each cell by arrayLength definition
 * @param param0
 * @returns
 */
export const incrementAccessor = (arrayLengths: number[], accessor: number[], incrementBy: number, idx: number = accessor.length - 1) => {
  const incrementedVal = accessor[idx] + incrementBy
  const quotiant = Math.floor(incrementedVal / arrayLengths[idx])
  const remainder = incrementedVal % arrayLengths[idx]
  accessor[idx] = remainder
  if (quotiant > 0 && idx > 0) {
    incrementAccessor(arrayLengths, accessor, quotiant, idx - 1)
  }
}

/**
 * @function getAccessorsBetween finds the accessors between two other accessors, used to determine where end and start of month skip over some buckets due to month length
 * @param param0
 * Limited to maxIterations (product of size of each nested array divided by incrementBy ) as it is possible that finalAccessor is repeatedly skipped eg due to increments where remainder is always zero
 * @returns accessor exclusively between initial and final
 */

export function getAccessorsBetween({ initialAccessor, finalAccessor, arrayLengths, incrementBy = 1 }: GetAccessorsBetweenRequest) {
  const currentAccessor = [...initialAccessor]
  const maxIterations = Math.floor(arrayLengths.reduce((a, c) => a * c)) / incrementBy

  const incremented: number[][] = []

  let i = 0
  let matches: boolean = true
  do {
    incrementAccessor(arrayLengths, currentAccessor, incrementBy)
    matches = currentAccessor.every((v, i) => v === finalAccessor[i])
    if (!matches) incremented.push([...currentAccessor])
    i++
  } while (i < maxIterations && !matches)
  return incremented
}
